// import {ReactComponent as SQLlogo} from '../assets/SQLLogo.svg';  

const Backend = {
    title: "Backend",
    icons: [
        { icon: "logos:python", name: "Python" },
        { icon: "logos:flask", name: "Flask" },
        { icon: "logos:nodejs-icon", name: "Node.js" },
        { name: "SQLAlchemy", icon: "devicon:sqlalchemy" },
        { icon: "devicon:sqlite", name: "SQLite" },
        { icon: "logos:redis", name: "Redis" },
        {icon: "simple-icons:celery", name: "Celery" },
        { icon: "logos:npm-icon", name: "NPM" },
        {icon: "mdi:database", name: "DBMS" },
        {name: "PostMan", icon: "devicon:postman" },
        {name: "JWT", icon: "devicon:jwt" },
    ]
};

export default Backend;